import React from 'react'
import LaverageTabsSection from '../../sections/LaverageTabsSection'
import { LeverageTabsSliceProps } from './types'

const LeverageTabsSlice: React.FC<LeverageTabsSliceProps> = ({ slice }) => {
  const { items = [] } = slice

  return (
    <LaverageTabsSection
      inner="inners.fullWidth"
      paddingTop={['40px', '', '160px']}
      paddingBottom={['40px', '', '195px']}
      headingPadding={['38px', '', '87px']}
      data={items.map((item, index) => {
        const { tab_title = '', tab_image, content_document } = item || {}
        const { title, badge, l_note, items = [] } = content_document?.document?.data || {}

        const list = items.map((item, index) => {
          const { heading_title, heading_description, content_title, content_description, content_formula } = item || {}

          return {
            key: `leverage-item-${index}`,
            heading:
              heading_title?.text || heading_description?.text
                ? {
                    title: heading_title?.text,
                    description: heading_description?.text
                  }
                : undefined,
            content: {
              title: content_title,
              description: content_description,
              formula: content_formula
            }
          }
        })

        return {
          id: `${index}`,
          tabKey: `${index}`,
          tabIcon: tab_image,
          title: tab_title,
          item: {
            heading: title?.text,
            badge,
            note: l_note,
            list
          }
        }
      })}
    />
  )
}

export default LeverageTabsSlice
